// custom typefaces
import "@fontsource-variable/montserrat"
import "@fontsource/merriweather"
// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks
import "prismjs/themes/prism.css"

// Add Content Security Policy for Twitter integration
export const onClientEntry = () => {
    // Add CSP meta tag if not already present
    if (typeof document !== 'undefined') {
        const existingCSP = document.querySelector('meta[http-equiv="Content-Security-Policy"]')
        if (!existingCSP) {
            const meta = document.createElement('meta')
            meta.setAttribute('http-equiv', 'Content-Security-Policy')
            meta.setAttribute('content', "script-src 'self' 'unsafe-inline' 'unsafe-eval' https://platform.twitter.com; frame-src 'self' https://platform.twitter.com https://syndication.twitter.com; connect-src 'self' https://backend.bisonvalley.app https://d267g51dg7ddym.cloudfront.net https://5yofno574c.execute-api.us-east-1.amazonaws.com;")
            document.head.appendChild(meta)
        }
    }
}
